import {Component, Input, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarDashboardComponent } from './toolbar-dashboard/toolbar-dashboard.component';
import { DxLoadPanelModule, DxScrollViewModule } from 'devextreme-angular';
import { Dates, analyticsPanelItems } from '../resource';
import { Observable, map, share, forkJoin } from 'rxjs';
import { DashboardService } from './dashboard.service';
import { OpportunitiesTickerComponent } from './opportunities-ticker/opportunities-ticker.component';
import { RevenueTotalTickerComponent } from './revenue-total-ticker/revenue-total-ticker.component';
import { ConversionTickerComponent } from './conversion-ticker/conversion-ticker.component';
import { LeadsTickerComponent } from './leads-ticker/leads-ticker.component';
import { RevenueCardComponent } from './revenue-card/revenue-card.component';
import { ConversionCardComponent } from './conversion-card/conversion-card.component';
import { RevenueAnalysisCardComponent } from './revenue-analysis-card/revenue-analysis-card.component';
import { RevenueSnapshotCardComponent } from './revenue-snapshot-card/revenue-snapshot-card.component';
import { inject } from '@angular/core';
import { PAGE_DATA } from '@dabnet-kamu/libs/ui';
type DashboardData = any | null;
type DataLoader = (startDate: string, endDate: string) => Observable<any>;
@Component({
  selector: 'dk-dashboard',
  standalone: true,
  imports: [
    CommonModule,
    ToolbarDashboardComponent,
    DxScrollViewModule,
    DxLoadPanelModule,
    OpportunitiesTickerComponent,
    RevenueTotalTickerComponent,
    ConversionTickerComponent,
    LeadsTickerComponent,
    RevenueCardComponent,
    ConversionCardComponent,
    RevenueAnalysisCardComponent,
    RevenueSnapshotCardComponent,
  ],
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  pageData = inject(PAGE_DATA);
  opportunities: any;
  analyticsPanelItems = analyticsPanelItems;
  isLoading = true;
  sales: any;
  salesByState: any;
  salesByCategory: any;

  constructor(private service: DashboardService) {}

  loadData = (startDate: string, endDate: string) => {
    this.isLoading = true;
    const tasks: Observable<object>[] = [
      ['opportunities', this.service.getOpportunitiesByCategory],
      ['sales', this.service.getSales],
      ['salesByCategory', this.service.getSalesByCategory],
      [
        'salesByState',
        (startDate: string, endDate: string) =>
          this.service
            .getSalesByStateAndCity(startDate, endDate)
            .pipe(map((data) => this.service.getSalesByState(data))),
      ],
    ].map(([dataName, loader]: [string, DataLoader] | any) => {
      const loaderObservable = loader(startDate, endDate).pipe(share());

      loaderObservable.subscribe((result: DashboardData) => {
        if (dataName) {
          (this as any)[dataName] = result;
        }
      });

      return loaderObservable;
    });

    forkJoin(tasks).subscribe(() => {
      this.isLoading = false;
    });
  };

  ngOnInit(): void {
    const [startDate, endDate] = analyticsPanelItems[4].value.split('/');

    this.loadData(startDate, endDate);
  }

  selectionChange(dates: Dates) {
    this.loadData(dates.startDate, dates.endDate);
  }
}
